// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5be3c77e","455":"d4737058"}[chunkId] + ".chunk.js";
};